import { OrderItem } from "@omni/types/api/cart/bff/shared/orderItem.model";
import * as OrderUtils from "@omni/utils/order.utils";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { formatPrice } from "@/utils/price.utils";

type PriceComponentProps = {
    item: OrderItem;
};

const PriceComponent = ({ item }: PriceComponentProps) => {
    const { t } = useGranite();

    return (
        <>
            {OrderUtils.showStrippedPrice(item) && (
                <s className="font-weight-light d-block">
                    {formatPrice(item.strikethroughPrice!)}
                </s>
            )}
            <div className="h4 font-weight-bold mb-0">
                {formatPrice(
                    item.unitPrice,
                    item.free ? { freeLabel: true, t: t } : undefined
                )}
            </div>
        </>
    );
};

export { PriceComponent };
